import { Button } from "@suraasa/placebo-ui"
import { Profile } from "api/resources/profile/types"
import { PhoneNumber } from "api/resources/users/types"
import { MASTERCLASS_ONBOARDING_TARGETS } from "features/Home/SuraasaPlusNewYearOnboarding/MasterclassOnboarding/types"
import { useState } from "react"

import PhoneDialog from "./PhoneDialog"
import { useRegisterMasterclass } from "./useRegisterMasterclass"

const RegisterButton = ({
  slug,
  profile,
  className,
  onSuccess,
  onError,
}: {
  slug: string
  profile: Profile
  className?: string
  onSuccess: () => void
  onError?: (e: any) => void
}) => {
  const [showPhoneDialog, setShowPhoneDialog] = useState(false)

  const register = useRegisterMasterclass({
    slug,
    profile,
    onSuccess: () => {
      onSuccess()
      setShowPhoneDialog(false)
    },
    onError: e => {
      onError?.(e)
    },
  })

  const handleClick = () => {
    if (!profile.phoneNumber) {
      setShowPhoneDialog(true)
      return
    }

    register.mutate({ phoneNumber: profile.phoneNumber })
  }

  const handleDialogSubmit = (phone: PhoneNumber) => {
    register.mutate({ phoneNumber: phone })
  }

  return (
    <>
      <Button
        onClick={handleClick}
        loading={register.isPending}
        color="black"
        className={className}
        data-tour={MASTERCLASS_ONBOARDING_TARGETS.reserveMySpot}
      >
        Reserve My Spot
      </Button>

      <PhoneDialog
        open={showPhoneDialog}
        onOpenChange={() => setShowPhoneDialog(false)}
        onSubmit={handleDialogSubmit}
        error={register.error}
        isLoading={register.isPending}
      />
    </>
  )
}

export default RegisterButton
